import { useMemo, useState } from "react";
import {
  MDSMenuItemVariant,
  MDSMenuItemSelectionVariant,
  MDSMenuDropdown,
  MDSMenuDropdownSlotName,
  MDSMenuItemDivider,
  MDSSelectMenu,
  MDSIconKind,
  MDSSelectMenuItem,
  MDSToggleButton,
} from "@/mds";
import { DateTime } from "luxon";
import { DateFacetFilterItem, RangeValue } from "./date-facet-filter.types";
import { DateFacetFilterDateRangePicker } from "@/components/filters/date-facet-filter/date-facet-filter-date-range-picker";

interface DateFacetFilterProps {
  items: DateFacetFilterItem[];
  selectedRange?: RangeValue;
  onClear: () => void;
}

export const DateFacetFilter = ({ items, onClear, selectedRange }: DateFacetFilterProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedItems = items.filter(item => item.type !== "any" && item.isSelected);

  const computedButtonLabel = useMemo(() => {
    if (!selectedItems.length) {
      return "Date";
    }

    if (selectedRange) {
      return `From ${DateTime.fromISO(selectedRange.start.toString()).toFormat("MMM d, yyyy")} to ${DateTime.fromISO(selectedRange.end.toString()).toFormat("MMM d, yyyy")}`;
    }

    return `${selectedItems[0].title}`;
  }, [selectedItems, selectedRange]);

  return (
    <div data-test-id="date-facet-filter">
      <MDSMenuDropdown onOpenChange={setIsOpen}>
        <MDSToggleButton
          slot={MDSMenuDropdownSlotName.Trigger}
          isOpen={isOpen}
          iconKind={MDSIconKind.CalendarDay}
          isToggled={selectedItems.length > 0}
          label={computedButtonLabel}
          onClear={onClear}
        />
        <MDSSelectMenu
          slot={MDSMenuDropdownSlotName.Menu}
          aria-label="Filter by media kinds"
          selectionBehavior="toggle"
          selectionMode="single"
          shouldFocusWrap={true}
          style={{ maxWidth: 320 }}
        >
          {items.map(item => {
            if (item.type === "any" || item.type === "older-than") {
              return (
                <MDSSelectMenuItem
                  key={item.title}
                  label={item.title}
                  id={item.title}
                  icon={MDSIconKind.CalendarDay}
                  isSelected={!!item.isSelected}
                  onClick={() => item.onSelect({ type: item.type })}
                  variant={MDSMenuItemVariant.OneLine}
                  selectionVariant={MDSMenuItemSelectionVariant.Checkmark}
                />
              );
            }
            if (item.type === "custom-range") {
              return (
                <>
                  <MDSMenuItemDivider />
                  <DateFacetFilterDateRangePicker
                    key={item.title}
                    item={item}
                    value={selectedRange || null}
                  />
                </>
              );
            }
          })}
        </MDSSelectMenu>
      </MDSMenuDropdown>
    </div>
  );
};
